module.exports = "// Memory type is a special global pre-defined type\nconst memory: Memory<{ initial: 1 }>;\n\n// An object of Memory type must be defined(can be imported)\n// to enable memory operations\n\nexport function test(): i32 {\n  // To use arrays simple define a type with array subscript\n  const arr: i32[] = 0;\n  // If arr is not defined with i32[] the below line would throw a SyntaxError\n  arr[0] = 20;\n  arr[1] = 15;\n\n  // This should return 35\n  return arr[0] + arr[1];\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./examples/walt/memory.walt
// module id = 923
// module chunks = 0